import React, { useContext, useEffect, useState } from "react";
import { IoMdMegaphone } from "react-icons/io";
import { MdNewReleases, MdOutlineFeaturedPlayList } from "react-icons/md";
import { FaArrowUpWideShort } from "react-icons/fa6";
import {
  usePatchNote,
  useHeader,
  useTheme,
  useManualUpload,
} from "../../hooks/index";
import Header from "../../components/HeaderComponent";
import { AuthContext } from "../../components/AuthContextComponent";
import { AutoLogout } from "../../components/AutoLogoutComponent";
import SecurityQuestion from "../../components/SecurityQuestion";
import { SecurityQuestionRequestArray } from "../../lib/interfaces/index";
import { forgetPassword } from "../../api/FetchAPI";
import { showAlert } from "../../promptMessages/PromptMessages";
import { ALERTMSG, STATUS } from "../../lib/enums/index";
import UpdatePassword from "../../components/updatepassword/UpdatePassword";
import LoadingComponent from "../../components/loading/Loading";
import useUserLogin from "../../hooks/UserLoginhook";
const PatchNotes = () => {
  const userInfo = useContext(AuthContext);
  const { username, setPartnerName } = useContext(AuthContext);
  const {
    feversion,
    frontEndPatchFeatures,
    frontEndPatchImprovements,
    beversion,
    releaseDate,
    newFeatures,
    improvements,
    PatchNote,
    fetchBEVErsion,
  } = usePatchNote();

  const { selectedPartner } = useManualUpload();
  const { Balance, customBannerImg } = useHeader(selectedPartner);
  const { pwdUpdate, category } = userInfo.userInfo || {};
  const { theme } = useTheme();
  const { openOTP } = useManualUpload();
  const { customColor } = useUserLogin();
  const [redirectModal, setRedirectModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentQuestions, setCurrentQuestions] =
    useState<SecurityQuestionRequestArray | null>(null);
  const [renderContent, setRenderContent] = useState<React.ReactNode>(null);

  const redirectState = !!(redirectModal && category === "EXTERNAL");

  const firstTimeLoginState = !!(pwdUpdate && category === "EXTERNAL");

  useEffect(() => {
    const fetchCurrentUserQuestion = async () => {
      // try {
      const response: any = await forgetPassword(username);

      const { respCode, respMsg, questionInfo } = response;

      if (respCode === 2000) {
        if (questionInfo === null || questionInfo < 2) {
          setCurrentQuestions(null);

          setRedirectModal(true);
        } else {
          setCurrentQuestions(questionInfo);
        }
      } else {
        showAlert(
          ALERTMSG.SOMEWENTWRONG,
          `${respMsg} (${respCode})`,
          "error",
          "",
          customColor,
          ""
        );
      }
      // } catch (error: any) {
      //   FetchErr(error, "", customColor, "");
      // }
    };

    let count = 0;
    if (count === 0) {
      const timer = setTimeout(() => {
        fetchCurrentUserQuestion();
      }, 1000);
      count++;
      return () => clearTimeout(timer);
    }
  }, [username]);
  setPartnerName("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // Set loading to true when fetching starts
      try {
        await PatchNote();
        // await handleBannerImg();
        await fetchBEVErsion();
        // You can call other fetching functions here if needed
        setTimeout(() => {
          if (pwdUpdate && category === STATUS.EXTERNAL) {
            setRenderContent(<UpdatePassword />);
          } else if (redirectModal && category === STATUS.EXTERNAL) {
            setRenderContent(<SecurityQuestion />);
          } else {
            setRenderContent(null);
          }
        }, 500);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData(); // Call the fetching function
  }, [username]);

  const allImprovements = [...improvements, ...frontEndPatchImprovements];
  const allFeatures = [...newFeatures, ...frontEndPatchFeatures];
  return (
    <div className="w-screen font-sans h-5/6">
      <Header Balance={Balance} theme={theme}></Header>

      <AutoLogout
        openOTP={openOTP}
        redirectModal={redirectState}
        redirectChangePassword={firstTimeLoginState}
      />

      {loading ? (
        <>
          <div className="flex items-center justify-center w-full h-full p-96">
            <LoadingComponent customColor={customColor} />
          </div>
        </>
      ) : (
        <>
          <div className="w-full px-10">
            <div className="flex items-center px-4 mt-10">
              <label
                htmlFor=""
                className={`flex items-center text-3xl font-bold ${
                  userInfo.userInfo?.theme === `DARK` ? `text-[#fafbfc]` : ``
                }`}
              >
                <IoMdMegaphone
                  className="mr-2 text-4xl text-custom-default-hover"
                  style={{ color: customColor }}
                />{" "}
                Patch Notes
              </label>
              <label
                htmlFor=""
                className={`mt-3 ml-2 font-bold  ${
                  userInfo.userInfo?.theme === `DARK` ? `text-[#fafbfc]` : ``
                }`}
              >
                v {feversion}.{beversion}
              </label>
            </div>
            <div className="w-full px-10 py-2">
              <label
                htmlFor=""
                className={`flex font-bold items-center ${
                  userInfo.userInfo?.theme === `DARK` ? `text-[#fafbfc]` : ``
                }`}
              >
                <MdNewReleases
                  className="mr-2 text-custom-default-hover"
                  style={{ color: customColor }}
                />
                Release Date: {releaseDate}
              </label>
            </div>
            <div className="flex justify-center w-full md:px-40">
              <div className="flex justify-between w-full items center">
                <div className="flex flex-col justify-center w-[50%]">
                  <div>
                    <label
                      htmlFor=""
                      className={`flex text-2xl font-bold items-center ${
                        userInfo.userInfo?.theme === `DARK`
                          ? `text-[#fafbfc]`
                          : ``
                      }`}
                    >
                      <MdOutlineFeaturedPlayList
                        className="mt-1 mr-2 text-custom-default-hover"
                        style={{ color: customColor }}
                      />
                      Features
                    </label>
                  </div>

                  {allFeatures.map((feature, index) => (
                    <div key={index} className="space-y-3">
                      {feature.split("\n").map((line, lineIndex) => (
                        <div key={lineIndex} className="mt-3 mr-10">
                          {line.split(" ").map((word: any, wordIndex: any) => (
                            <span
                              key={wordIndex}
                              className={`${
                                lineIndex === 0
                                  ? `font-semibold ${
                                      userInfo.userInfo?.theme === `DARK`
                                        ? `text-[#fafbfc]`
                                        : ``
                                    }`
                                  : word
                                  ? "text-custom-default-hover font-bold"
                                  : ""
                              }`}
                            >
                              {word}{" "}
                            </span>
                          ))}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
                <div className="flex flex-col  justify-center w-[50%] mt-10">
                  <div>
                    <label
                      htmlFor=""
                      className={`flex text-2xl font-bold items-center ${
                        userInfo.userInfo?.theme === `DARK`
                          ? `text-[#fafbfc]`
                          : ``
                      }`}
                    >
                      <FaArrowUpWideShort
                        className="mr-2 text-custom-default-hover"
                        style={{ color: customColor }}
                      />
                      Improvements
                    </label>
                  </div>

                  {allImprovements.map((imp, index) => (
                    <div key={index} className="space-y-3">
                      {imp.split("\n").map((line, lineIndex) => (
                        <div key={lineIndex} className="mt-3 mr-10">
                          {line.split(" ").map((word: any, wordIndex: any) => (
                            <span
                              key={wordIndex}
                              className={`${
                                lineIndex === 0
                                  ? `font-semibold ${
                                      userInfo.userInfo?.theme === `DARK`
                                        ? `text-[#fafbfc]`
                                        : ``
                                    }`
                                  : word
                                  ? "text-custom-default-hover font-bold"
                                  : ""
                              }`}
                            >
                              {word}{" "}
                            </span>
                          ))}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {renderContent}
    </div>
  );
};

export default PatchNotes;
